//import React from "react";
//import Navbar from "../components/Navbar";
//import { Card } from "@mui/material";
//import "../App.css";
//import pageBg from "../assets/banka-bg.svg";
//import cardSvg from "../assets/banka.svg";

//export default function BankaTaksitBilgileri() {
//    return (
//        <div
//            className="page-container no-overlay"
//            style={{
//                backgroundImage: `url(${pageBg})`,
//                backgroundSize: "cover",
//                backgroundPosition: "center",
//                backgroundRepeat: "no-repeat",
//            }}
//        >
//        <div
//            className="page-container"
//            style={{
//                backgroundImage: `url(${pageBg})`,
//                backgroundSize: "cover",
//                backgroundPosition: "center",
//                backgroundRepeat: "no-repeat",
//            }}
//        >
//            <Navbar />

//            <div className="page-content">
//                <Card className="banka-card">
//                    <img src={cardSvg} alt="Banka Taksit Bilgileri" className="banka-img" />
//                </Card>
//            </div>
//            </div>
//        </div>
//    );
//}

//import React from "react";
//import Navbar from "../components/Navbar";
//import { Card } from "@mui/material";
//import "../App.css";
//import pageBg from "../assets/bg.svg";   // <-- DEĞİŞTİ !!!
//import cardSvg from "../assets/banka.svg";

//export default function BankaTaksitBilgileri() {
//    return (
//        <div
//            className="page-container"
//            style={{
//                backgroundImage: `url(${pageBg})`,
//                backgroundSize: "cover",
//                backgroundPosition: "center",
//                backgroundRepeat: "no-repeat",
//            }}
//        >
//            <Navbar />

//            <div className="page-content no-overlay">
//                <Card className="banka-card">
//                    <img src={cardSvg} alt="Banka Taksit Bilgileri" className="banka-img" />
//                </Card>
//            </div>
//        </div>
//    );
//}
import React from "react";
import Navbar from "../components/Navbar";
import { Card } from "@mui/material";
import "../App.css";
import cardSvg from "../assets/banka.svg";

export default function BankaTaksitBilgileri() {
    return (
        <div className="page-container banka-bg-off">
            <Navbar />

            <div className="page-content">
                <Card className="banka-card">
                    <img src={cardSvg} alt="Banka Taksit Bilgileri" className="banka-img" />
                </Card>
            </div>
        </div>
    );
}






